import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/patent');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('patent', validationApi);

export function getPatentValidationHistoryOptions(patentId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(patentId);
}

export function getPatentValidationOptions(patentId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(patentId);
}

export function useValidatePatent(patentId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(patentId, queryClient));
}
